export const EBuildingListDisplayMode = {
  GRID: 'grid',
  LIST: 'list',
};

export enum EBuildingAssignments {
  SUPERVISOR = 'supervisor',
  CLEANER = 'cleaner',
}
